import {
  SearchActionType,
  SearchNameType,
  SearchTypeTypes,
  trackOriginClick,
  trackSearch,
} from '@aboutyou/legacy-tracking-sdk';
import {searchEventTypes} from '../context/TrackingClientContext';
import {useTracking} from '../utils/utils';

export const useTrackSearch = () => {
  const {TrackingClient} = useTracking();

  return ({
    searchTerm,
    searchName,
    searchAction,
    searchType,
    searchTermCompleted,
    searchDestination,
  }: {
    searchTerm?: string;
    searchName?: SearchNameType;
    searchAction: SearchActionType;
    searchType?: SearchTypeTypes;
    searchTermCompleted?: string | null;
    searchDestination?: string;
  }) => {
    TrackingClient.track(trackOriginClick({origin: 'search'}));
    TrackingClient.track(() =>
      trackSearch({
        label: searchTerm || '',
        action: searchAction,
        name: searchName || '',
        searchTermCompleted: searchTermCompleted || '',
        searchDestination: searchDestination || '',
        searchType: searchType || '',
      }),
    );
  };
};

export const useSearchEventsUtils = () => {
  const {
    updateSearchEventParams,
    getSearchEventParams,
    resetSearchEventParams,
  } = useTracking();

  return {
    updateSearchEventContextParams: (
      params: Omit<searchEventTypes, 'shouldFire'>,
    ) => updateSearchEventParams(params),
    searchEventContextParams: getSearchEventParams(),
    resetEventContextParams: resetSearchEventParams,
  };
};
